import { useQuery } from "@tanstack/react-query"

import {
  DEFAULT_QUERY_CACHE_TIME as QUERY_CACHE_TIME,
  DEFAULT_QUERY_STALE_TIME as QUERY_STALE_TIME,
} from "@/modules/api/constants"
import { SEEN_JOB_ADS_QUERY_KEY } from "@/modules/jobAds/client/api/constants"
import { getSeenJobAds } from "@/modules/jobAds/client/api/getSeenJobAds"
import { JOB_ADS_FO_SEEN_CARD, JOB_ADS_FO_SEEN_CARD_VARIANTS } from "@/modules/jobAds/client/constants/flags"
import { useFlag } from "@/modules/unleash/hooks/useFlag"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

type SeenJobAdsFetch = {
  seenJobAds: string[]
  isLoadingSeenJobAds: boolean
  isSuccessSeenJobAds: boolean
  isErrorSeenJobAds: boolean
}

export const useSeenJobAds = (): SeenJobAdsFetch => {
  const { dataCurrentUser } = useCurrentUserFetch()
  const isLogged = dataCurrentUser?.isLogged || false
  const isSeenJobAdsFeatureEnabled = useFlag(JOB_ADS_FO_SEEN_CARD, JOB_ADS_FO_SEEN_CARD_VARIANTS.ENABLED)

  const {
    data,
    isPending: isLoadingSeenJobAds,
    isSuccess: isSuccessSeenJobAds,
    isError: isErrorSeenJobAds,
  } = useQuery<string[], Error, void, [typeof SEEN_JOB_ADS_QUERY_KEY]>({
    enabled: isSeenJobAdsFeatureEnabled && isLogged,
    gcTime: QUERY_CACHE_TIME,
    queryFn: () => getSeenJobAds(),
    queryKey: [SEEN_JOB_ADS_QUERY_KEY],
    staleTime: QUERY_STALE_TIME,
  })

  return {
    isErrorSeenJobAds,
    isLoadingSeenJobAds,
    isSuccessSeenJobAds,
    seenJobAds: data || [],
  }
}
